import { useCurrentStep } from './useCurrentStep';
import { Tracker } from '../store/tracking/action-creators';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { useSelector, useDispatch } from 'react-redux';
import { getGuessedDataBreeze } from '../store/guessed-prefill/selectors';
import { getShouldUseBreezeCompanyInfo } from '../utils/getShouldUseBreezeCompanyInfo';
export const useSearchAndPrefillExperiment = () => {
  const {
    currentStep
  } = useCurrentStep();
  const dispatch = useDispatch();
  const companyName = useSelector(state => getSignupDataValue(state, Data.CompanyName));
  const guessedCompanyName = useSelector(getGuessedDataBreeze(Data.CompanyName));
  const shouldUseBreezeCompanyInfo = getShouldUseBreezeCompanyInfo();
  const trackCompanyNameChanged = () => {
    if (shouldUseBreezeCompanyInfo) {
      if (companyName !== guessedCompanyName) {
        dispatch(Tracker.signupInteraction('breeze-company-name-prefilled-changed'));
      }
    }
  };
  const searchAndPrefillHelperText = shouldUseBreezeCompanyInfo ? `views.${currentStep}.searchAndPrefillHelperText` : `views.${currentStep}.help`;
  return {
    shouldUseBreezeCompanyInfo,
    searchAndPrefillHelperText,
    trackCompanyNameChanged
  };
};